import { render } from "./Marque.vue?vue&type=template&id=04e20ab3"
import script from "./Marque.vue?vue&type=script&lang=js"
export * from "./Marque.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__